import React from 'react';
import { FolderInput, Brain, Building2, Upload } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Drop the property intake',
    body:
      'Point Sortio at your Downloads folder, your shared property management drive, or per-property folders. Lease packets, maintenance reports, vendor invoices, owner statements, tenant correspondence: everything you handle in a typical month.',
  },
  {
    icon: Brain,
    title: 'Read by property and unit',
    body:
      'Sortio extracts the property address, unit number, tenant name, lease dates, and document type from each file. A maintenance work order at 1127 Cornell Apt 4B gets recognized as a separate entity from Apt 4A or the building common area.',
  },
  {
    icon: Building2,
    title: 'Route per unit and lease',
    body:
      'Each file lands under the right Property / Unit / Lease folder structure. Tenant ledger PDFs and lease packets follow the active lease; vendor invoices follow the property; maintenance reports follow the work order. You preview every assignment before files move.',
  },
  {
    icon: Upload,
    title: 'Upload to Buildium or Rent Manager',
    body:
      'When the integrations ship, files routed to a property in Sortio upload directly into the matching Buildium or Rent Manager entity (property, unit, lease, work order). Until then, files land cleanly on disk and you upload through the platform UI in batches.',
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How per-unit filing works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a mixed-property document pile to clean per-unit and per-lease folders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div key={i} className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">Step {i + 1}</span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
